import React, { useEffect, useState } from "react";

import RpMUIModalBase from "@/components/modals/RpMUIModal";
import JoinCampaignLocationBase from "./JoinCampaignLocation";

type EditLocationModalProps = {
  location?: unknown;
  onClose?: () => void;
  campaign?: unknown;
  onSave?: (..._args: unknown[]) => void;
};

const RpMUIModal = RpMUIModalBase as unknown as React.ComponentType<
  Record<string, unknown>
>;
const JoinCampaignLocation =
  JoinCampaignLocationBase as unknown as React.ComponentType<
    Record<string, unknown>
  >;

function EditLocationModal({
  location,
  onClose,
  campaign,
  onSave,
}: EditLocationModalProps) {
  const [open, setOpen] = useState(false);

  const handleOnClose = () => {
    setOpen(false);
    onClose?.();
  };

  useEffect(() => {
    setOpen(!!location);
  }, [location]);

  return (
    <RpMUIModal open={open} onClose={handleOnClose} maxWidth="lg" persists>
      <JoinCampaignLocation
        loc={location}
        campaign={campaign}
        onClose={handleOnClose}
        onSave={onSave}
      />
    </RpMUIModal>
  );
}

export default EditLocationModal;
